// ─── Common filter framework — shared core (f-02062) ──────────────
// Entity-agnostic, keyed by listId. Tickets is the only adopter so far; every
// other list keeps components/ListFilters.tsx until it migrates (see the
// "Filter framework" chapter of docs/ui-design-guide.md).
import { registerFilterList } from './registry.js';
import { TICKETS_FILTER_LIST } from './tickets.js';
export * from './model.js';
export * from './ops.js';
export * from './registry.js';
export * from './validate.js';
export * from './pattern.js';
export * from './describe.js';
export * from './normalize.js';
export * from './codec.js';
export * from './evaluate.js';
export * from './layout.js';
export * from './icons.js';
export * from './colors.js';
export * from './saved.js';
export * from './api.js';
export * from './tickets.js';
// Built-in lists. A second adopter adds its descriptor module and one line here.
registerFilterList(TICKETS_FILTER_LIST);
//# sourceMappingURL=index.js.map